module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-09.409e36fb.png";